import {
  DateRangeFilterValueLike,
  dateRangeFilterValueToRange,
} from '@app/components/date-range-selector/date-range-filter-value-to-range';
import { ListViewFilters, ListViewSort } from '@app/core/list-view/types';
import { DateTimeStr, toDateTimeStr } from '@mi-front/core';

/**
 * Resolves ListView filter values into `fetchAudios` filter fields.
 * Date presets are computed in the station timezone; material ID is a contains match.
 */
export function audiosListFiltersToApi(
  filters: ListViewFilters | null | undefined,
  timezone: string,
): {
  from?: DateTimeStr;
  to?: DateTimeStr;
  customIdLike?: string;
} {
  const dateRange = (filters?.dateRange ?? null) as DateRangeFilterValueLike | null;
  const { from, to } = dateRangeFilterValueToRange(dateRange, { timezone });
  const customId = typeof filters?.customId === 'string' ? filters.customId.trim() : '';

  return {
    from: from ? toDateTimeStr(from) : undefined,
    to: to ? toDateTimeStr(to) : undefined,
    customIdLike: customId ? `%${customId}%` : undefined,
  };
}

/**
 * Builds the audit audios API sort string. Defaults to newest upload first.
 */
export function audiosListSortToApi(sort: ListViewSort | null | undefined): string {
  if (!sort?.id) {
    return 'createdAt desc';
  }

  return `${sort.id} ${sort.desc ? 'desc' : 'asc'}`;
}
